import Footer from '../../../components/Footer'
import Header from '../../../components/Header'
import GestorList from '../../../components/GestorList'

export default function Gestor() {
  return (
    <>
        <Header/>
        <GestorList/>
        <Footer/>
    </>
  )
}
